import axios from "axios";

const REACT_APP_API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

const VCatKitService = {
    createVCatKit: async (kitData: any) => {
        const token = localStorage.getItem("authToken");
        if (!token) {
            throw new Error("Unauthorized: No token found.");
        }
        
        try {
            const response = await axios.post(`${REACT_APP_API_URL}/vcat-kit/`, kitData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            return response.data;
        } catch (error) {
            console.error("Error creating VCat Kit:", error);
            throw new Error("Failed to create VCat Kit.");
        }
    },
    getVCatKitDetails: async (kitId: number) => {
        const token = localStorage.getItem("authToken");
        if (!token) {
            throw new Error("Unauthorized: No token found.");
        }

        try {
            const response = await axios.get(`${REACT_APP_API_URL}/vcat-kit/${kitId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching VCat Kit details:", error);
            throw new Error("Failed to fetch VCat Kit details.");
        }
    },

    getAllVCatKits: async () => {
        const token = localStorage.getItem("authToken");
        if (!token) {
            throw new Error("Unauthorized: No token found.");
        }

        try {
            const response = await axios.get(`${REACT_APP_API_URL}/vcat-kit/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching all VCat Kits:", error);
            throw new Error("Failed to fetch all VCat Kits.");
        }
    },

    updateVCatKit: async (kitId: number, updatedData: any) => {
        const token = localStorage.getItem("authToken");
        if (!token) {
            throw new Error("Unauthorized: No token found.");
        }

        try {
            const response = await axios.put(
                `${REACT_APP_API_URL}/vcat-kit/${kitId}`,
                updatedData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error updating VCat Kit:", error);
            throw new Error("Failed to update VCat Kit.");
        }
    },
    deleteVCatKit: async (kitId: number) => {
        const token = localStorage.getItem("authToken");
        if (!token) {
            throw new Error("Unauthorized: No token found.");
        }

        try {
            const response = await axios.delete(`${REACT_APP_API_URL}/vcat-kit/${kitId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            return response.data;
        } catch (error) {
            console.error("Error deleting VCat Kit:", error);
            throw new Error("Failed to delete VCat Kit.");
        }
    },
};

export default VCatKitService;
